// En el archivo Inicio.js
import React from 'react';
import Historia from '../components/Historia';
import Opciones from '../components/Opciones';
import Horario from '../components/Horario';
import DeliveryPhoto from './../img/Inicio/Delivery.jpg'

import './../css/Inicio.css'
import NuestroShop from '../components/NuestroShop';
import Contactanos from '../components/Contactanos';

function Inicio() {
  return <div>
    <Historia />
    <Opciones />
    <NuestroShop />
    <div className='inicio__cont'>
      <div className='inicio__cont__img'>
        <img src = {DeliveryPhoto} className='inicio__cont__img__detail'/>        
      </div>

      <Horario className = "inicio__cont__horario"/>  
         
    </div>
  <Contactanos /> 
  </div>;
}

export default Inicio;

